import MxListContentSection from "@rf-l1/page/list/MxListContentSection";
import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { memo } from "react";
import countFormat from "@rf-helper/format/count-format";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import { CPropertyDraftListFilterKeys } from "../util/propertyDraftListFilter";
import PropertyDraftDeleteAllButton from "./PropertyDraftDeleteAllButton";

const PropertyDraftMainFilters = memo(({ total }: { total: number }) => {
  return (
    <MxListContentSection
      container
      position="sticky"
      top={0}
      sx={{
        backgroundColor: "background.paper",
        zIndex: 1003
      }}
    >
      <Grid container spacing={1} alignItems="center">
        <Grid item xs="auto">
          <MxTypography variant="subtitle2" color="primary.main" fontWeight={800}>
            Borradores de propiedades
          </MxTypography>
        </Grid>

        <Grid item xs={"auto"} md={1.5}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            items={[
              { label: "Proyectos", value: "Si", id: 1 },
              { label: "Propiedades", value: "No", id: 0 }
            ]}
            name={CPropertyDraftListFilterKeys.typeDraft}
            label="Tipo de borrador"
          />
        </Grid>
        <Grid item xs={12} sm={"auto"} ml={1}>
          <MxTypography
            variant="caption"
            color="grey.700"
            lines={1}
            id="total-drafts"
            data-testid="total-drafts"
          >
            {countFormat(total) || 0} borradores encontrados
          </MxTypography>
        </Grid>

        <Grid flex={1} sx={{ display: { xs: "none", sm: "block" } }}></Grid>
        <PropertyDraftDeleteAllButton />
      </Grid>
    </MxListContentSection>
  );
});

PropertyDraftMainFilters.displayName = "PropertyDraftMainFilters";
export default PropertyDraftMainFilters;
